import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PlanTooltip from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-tooltip.vue";
import { ACCOUNT_PLAN_PAGE } from "@Broker/@Utils/enum";
import { GET_USAGE_REMAINING_FOR_PAGE, IS_USAGE_RESTRICTED } from "@Broker/@Modules/account-plan/store/account-plan-getters";
import { LOAD_PLAN_LIMIT } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { TRIGGER_BY_KEY } from "../../store/automation-getters";
import { UPDATE_APPLICATION_AUTOMATION_STATUS } from "../../store/automation-actions";
import { SET_CHANGING_AUTOMATION_STATUS } from "../../store/automation-mutations";
import ApplicationAutomationSingleDetails from "./application-automation-single-details";
import { debounce, isEmpty, lowerCase } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "ApplicationAutomationSingle",
  components: {
    ApplicationAutomationSingleDetails,
    PlanTooltip
  },
  props: {
    automation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      detailsToggled: false,
      labelValue: uuidv4()
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AutomationStore", [TRIGGER_BY_KEY])), mapGetters("AccountPlanStore", [IS_USAGE_RESTRICTED, GET_USAGE_REMAINING_FOR_PAGE])), mapState("AutomationStore", ["changingAutomationStatus"])), {}, {
    trigger() {
      return this.TRIGGER_BY_KEY(this.automation.trigger, "application");
    },
    triggerArguments() {
      return this.automation["trigger-arguments"];
    },
    actionArguments() {
      return this.automation["action-arguments"];
    },
    time() {
      return this.triggerArguments.time;
    },
    timeWithoutsign() {
      return Math.abs(this.time.value);
    },
    timeName() {
      if (this.timeWithoutsign === 0) return "";
      const period = pluralize(this.time.type, 1);
      return `${this.timeWithoutsign} ${this.$tc(`global.words.${period}`, this.timeWithoutsign).toLowerCase()}`;
    },
    dataSource() {
      return this.triggerArguments.dataSource;
    },
    timeTermDescription() {
      if (this.time.value === 0) return this.$t("automations.applicationLevel.onTimeValue", {
        value: lowerCase(this.trigger.description)
      });
      const timeTerm = this.time.value < 0 ? "priorToTheValue" : "afterTheValue";
      return this.$t(`automations.applicationLevel.${timeTerm}`, {
        value: lowerCase(this.dataSource.value)
      });
    },
    automationIsActive() {
      const validActiveStatus = ["sent", "active"];
      return _includesInstanceProperty(validActiveStatus).call(validActiveStatus, this.actionArguments.status);
    },
    emptyActionArguments() {
      return !this.actionArguments.campaignId;
    },
    currentAccountPlanPage() {
      return ACCOUNT_PLAN_PAGE.APPLICATION_LEVEL_AUTOMATION;
    },
    reachMaxUsage() {
      return this.IS_USAGE_RESTRICTED(this.currentAccountPlanPage);
    },
    disabledAutomation() {
      return this.changingAutomationStatus || this.reachMaxUsage && !this.automationIsActive || this.emptyActionArguments;
    },
    automationDisabledReason() {
      if (this.emptyActionArguments) return this.$t("automations.applicationLevel.thisAutomationHasNotBeenSetup");
      if (this.reachMaxUsage) return this.$t("automations.applicationLevel.maxUsageReached");
      return null;
    },
    isDateOfBirth() {
      return this.trigger.key === "date_of_birth";
    }
  }),
  watch: {
    automation(value) {
      if (!isEmpty(value["action-arguments"])) this.destroyTooltip();
    }
  },
  mounted() {
    this.$nextTick(() => $(this.$refs.statusTooltip).tooltip());
    const {
      openAutomation: paramOpenAutomation
    } = this.$route.params;
    const openAutomation = _parseInt(paramOpenAutomation);
    if (openAutomation != null && openAutomation === this.automation.id) {
      this.detailsToggled = true;
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("AutomationStore", [UPDATE_APPLICATION_AUTOMATION_STATUS])), mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT])), mapMutations("AutomationStore", [SET_CHANGING_AUTOMATION_STATUS])), {}, {
    handleToggleAutomationStatus: debounce(async function ({
      target
    }) {
      this.SET_CHANGING_AUTOMATION_STATUS(true);
      const newStatus = target.checked ? "active" : "inactive";
      const newDetails = {
        "action-arguments": _objectSpread(_objectSpread({}, this.actionArguments), {}, {
          status: newStatus
        })
      };
      const automation = _objectSpread(_objectSpread({}, this.automation), newDetails);
      await this.UPDATE_APPLICATION_AUTOMATION_STATUS({
        automation
      });
      this.SET_CHANGING_AUTOMATION_STATUS(false);
      this.LOAD_PLAN_LIMIT(this.currentAccountPlanPage);
    }, 200),
    handleSeeAutomationDetails() {
      this.detailsToggled = !this.detailsToggled;
    },
    destroyTooltip() {
      $(this.$refs.statusTooltip).tooltip("dispose");
    }
  })
});